import { TopBarMessageResponse } from '@interfaces/models';
import { httpClient } from '@api/interceptors';

export async function getTopbarMessage(
  isDashboardWelcomeVisible: boolean,
): Promise<TopBarMessageResponse> {
  return httpClient
    .get<TopBarMessageResponse>('topbar-message', { searchParams: { isDashboardWelcomeVisible } })
    .json();
}
